<template>
  <div class="review border-lg shadow-light pa-7 self-start">
    <div class="flex col justify-between">
      <div>
        <div class="flex justify-center">
          <StarIcon v-for="_ in 5" />
        </div>
        <div class="content mt-5 text-start">
          <p v-html="quoteText(testimonial.body)" class="lead" />
          <p><a :href="testimonial.url" target="_blank">
            {{ $tt('page.testimonials.read_original') }}&nbsp;{{ getLinkArrow() }}
          </a></p>
        </div>
      </div>
      <div class="details mt-6 flex items-center justify-between">
        <div>
          <p class="text-start"><strong>{{ testimonial.name }}</strong></p>
          <p>{{ testimonial.date }}</p>
        </div>
        <AppImg :src="`/images/companies/${testimonial.img}`" :alt="testimonial.name" edgy />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Testimonial } from '~/types';
defineProps<{
  testimonial: Testimonial;
}>();
const { quoteText, getLinkArrow } = useFormat();
</script>

<style lang="scss" scoped>
.review {
  max-width: 360px;
}
.content {
  height: 125px;
}
.lead {
  line-height: var(--lh-md);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
a {
  font-size: 16px;
}
.details p {
  font-size: 16px;
}
img {
  height: 25px;
}

@media (max-width: 850px) {
  .review {
    max-width: none;
    width: calc(100vw - (2 * var(--space-4)));
  }
}
</style>